module.exports = __webpack_public_path__ + "static/note-location-dont-d9ae173459521d92bc188b59886591f3.png";